/**
 * Learn more about using TypeScript with React Navigation:
 * https://reactnavigation.org/docs/typescript/
 */
/* eslint-disable */
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { CareRecipientCreatedConfirmationScreenParams } from '../screens/member/new/confirmation';
import { FillCareRecipientInformationScreenParams } from '../screens/member/new/fillInformation';
import { FillCareRecipientInformationConfirmationParams } from '../screens/member/new/fillInformationConfirmation';
import { NewTeamScreenParams } from '../screens/team/new';
import { OrganisationTeamScreenParams } from '../screens/team/view';
import { AssignMemberToTeamsScreenParams } from '../screens/member/teams/assign';
import { AddMembersToTeamScreenParams } from '../screens/team/view/add-members';
import { EditTeamScreenParams } from '../screens/team/edit';
import { NewTemporaryAccessScreenParams } from '../screens/member/temporary-access';

declare global {
	namespace ReactNavigation {
		interface RootParamList extends OrganisationsStackParamsList {}
	}
}

type MemberType = 'caregiver' | 'careRecipient';

type OrganisationView = {
	uuid: string;
};

export type OrganisationsStackParamsList = {
	Home: OrganisationView;
	OrganisationView: OrganisationView;
	AllTermsOfUse: { uuid: string };
	TermsOfUseView: { uuid: string; text: string; updatedAt: string };
	NewTermsOfUse: { uuid: string };
	AcceptTermsOfUse: { uuid: string };
	EditOrganisation: { uuid: string };
	NewOrganisationMember: { organisationUuid: string; type: MemberType };
	ImportOrganisationMember: {
		organisationUuid: string;
		type: Extract<MemberType, 'careRecipient'>;
	};
	CareRecipientCreatedConfirmation: CareRecipientCreatedConfirmationScreenParams;
	FillCareRecipientInformation: FillCareRecipientInformationScreenParams;
	FillCareRecipientInformationConfirmation: FillCareRecipientInformationConfirmationParams;
	NewTeam: NewTeamScreenParams;
	NewPost: undefined;
	EditTeam: EditTeamScreenParams;
	OrganisationTeam: OrganisationTeamScreenParams;
	AssignMemberToTeams: AssignMemberToTeamsScreenParams;
	AddMembersToTeam: AddMembersToTeamScreenParams;

	InviteToConnect: {
		userUuid: string;
		fullNameOrUsername: string;
	};
	Profile: { userId: string };

	Invitations: { organisationUuid: string };
	NewTemporaryAccess: NewTemporaryAccessScreenParams;
};

export type RootStackScreenProps<Screen extends keyof OrganisationsStackParamsList> =
	NativeStackScreenProps<OrganisationsStackParamsList, Screen>;
